<template>
    <div class="section-main__warp personCm personControl">
        <div class="roster-manage-page">
            <!-- 布控状态按钮组 -->
            <div class="table-tool">
                <el-button type="text"
                           class="iss-operation-button"
                           icon="el-icon-plus"
                           @click="createControl"
                           v-auth="'/personControl/manage:add'">
                  {{$t('personCm.button.create')}}
                </el-button>
                <el-button type="text" class="iss-operation-button" icon="iconfont icon-qiyong" @click="startControlNums(1)" v-auth="'/personControl/manage:startStop'">{{$t('personCm.button.start')}}</el-button>
                <el-button type="text" class="iss-operation-button" icon="iconfont icon-jinyong1" @click="prohibitControlNums(2)" v-auth="'/personControl/manage:startStop'"> {{$t('personCm.button.disable')}}</el-button>
            </div>
            <!-- 布控任务展示 -->
            <ioc-table
              :option="optionTabTask"
              :data="taskCenterData"
              :page="page"
              @size-change="sizeChange"
              @current-change="currentChange"
              @selection-change="handleSelectionChange"
              @search-change="searchTask"
              @search-reset="resetform"
              ref="iocCrud">
                <!-- 搜索框  -->
                <template slot="search_bayonetList">
                    <div style="flex:1;position:relative">
                      <el-input placeholder="请选择" @click.native="sxjz" class="bukongObject" v-model="searchData.bayonetList"></el-input>
                      <div v-if="groupList" style="background:#383f6e;position:absolute;bottom:-205px;width:100%;z-index:999999;height:200px;box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.4);">
                        <div style="position:relative;height:100%;background:#23365d">
                          <app-camers-group type="2" :bayonetListType="2" @changeCamersGroup="changeCamersGroup" :isRequired="true" style="width:100%;height:100%;position;inherit;right:0;top:0"></app-camers-group>
                        </div>
                      </div>
                    </div>
                </template>
                <template slot="search_repositoriesCode">
                  <el-select style="width:200px"
                             v-model="searchData.repositoriesCode"
                             placeholder="请选择"
                             filterable
                             multiple
                             collapse-tags>
                    <el-option style="width:200px"
                      v-for="item in faceGroup"
                      :key="item.value"
                      :label="item.name"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </template>
                <!-- 布控列表-按钮操作栏 -->
                <template slot="menu" slot-scope="scope">
                    <el-tooltip class="item m5" effect="dark" :content="$t('personCm.placeholder.modification')" placement="top-start">
                        <span class="icon iconfont icon-blue icon-xiugai" @click="editControl(scope.row)" v-auth="'/personControl/manage:update'"></span>
                    </el-tooltip>
                    <el-tooltip class="item m5" effect="dark" :content="$t('personCm.placeholder.delete')" placement="top-start">
                        <span class="icon iconfont icon-blue icon-shanchu" @click="deleteControl(scope.row)" v-auth="'/personControl/manage:delete'"></span>&nbsp;&nbsp;&nbsp;&nbsp;
                    </el-tooltip>
                    <el-tooltip v-if="scope.row.status === 2" class="item m5" effect="dark" :content="$t('personCm.placeholder.enabled')" placement="top-start">
                        <span class="icon iconfont icon-blue icon-qiyong" @click="openControl(scope.row,1)" v-auth="'/personControl/manage:startStop'"></span>&nbsp;&nbsp;&nbsp;&nbsp;
                    </el-tooltip>
                    <el-tooltip v-if="scope.row.status === 1" class="item m5" effect="dark" :content="$t('personCm.placeholder.disable')" placement="top-start">
                        <span class="icon iconfont icon-blue icon-jinyong1" @click="openControl(scope.row,2)" v-auth="'/personControl/manage:startStop'"></span>&nbsp;&nbsp;&nbsp;&nbsp;
                    </el-tooltip>
                </template>
            </ioc-table>
        </div>
      <!-- 名单组选择弹框 -->
      <app-person-group-list ref="appPersonGroupList" @group="groupChange"/>
      <el-dialog :title="action" v-dialogDrag :visible.sync="controlWindowShow" :modal="false" width="780px" :before-close="closeDia" @close="cancelListForm">
        <el-form :inline="true" ref="ruleForm" label-width="120px" :model="formNew" :rules="rules" :status-icon="true">
          <el-form-item :label="$t('personCm.label.name')" prop="name" style="width: 45%;">
            <el-input v-model="formNew.name" :placeholder="$t('personCm.placeholder.name')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('personCm.label.type')" prop="hitType" style="width: 50%;">
            <el-select v-model="formNew.hitType" style="width:93%" placeholder="请选择">
              <el-option
                v-for="item in hitTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('personCm.label.object')" prop="repositoriesCode" style="width: 45%;">
            <el-select v-model="formNew.repositoriesCode"
                       placeholder="请选择"
                       filterable
                       style="width: 200px;"
                       multiple
                       collapse-tags>
              <el-option
                v-for="item in faceGroup"
                :key="item.value"
                :label="item.name"
                :value="item.code"
                style="width: 200px;">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 摄像机组 -->
          <el-form-item :label="$t('personCm.label.cameraGroup')" prop="bayonetList" style="width: 50%;">
            <el-input placeholder="请选择" @click.native="sxjzList" class="bukongObject" v-model="showBayonetList"></el-input>
            <div v-if="groupListCreate" style="background:#383f6e;position:absolute;bottom:-205px;width:100%;z-index:999999;height:200px;box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.4);">
              <div style="position:relative;height:100%;background:#23365d">
                <app-camers-group type="2" @changeCamersGroup="changeCamersGroup" :isRequired="true" style="width:100%;height:100%;position;inherit;right:-10px;top:0"></app-camers-group>
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="$t('personCm.label.threshold')" style="width: 100%;">
            <div style="display:flex;align-items:center">
              <div>
                <el-slider v-model="formNew.confidenceThreshold" style="width:180px"></el-slider>
              </div>
              <div style="margin-left:5px">
                {{formNew.confidenceThreshold}}
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="$t('personCm.label.describe')" style="width: 100%;">
            <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="formNew.description" style="background:#606266;width:350px"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">
            {{ $t('deviceMg.button.save') }}
          </el-button>
          <el-button @click="controlWindowShow = false">
            {{ $t('deviceMg.button.Cancel') }}
          </el-button>
        </div>
      </el-dialog>
      <el-dialog :title="$t('deviceMg.title.add')" v-dialogDrag :visible.sync="cameraWindowShow" :modal="false" width="780px">
        <app-camers-group type="2" :isRequired="true" style="position:inherit"></app-camers-group>
      </el-dialog>
    </div>
</template>

<script>
import { api } from '../api'
import utils from '@src/common/utils'
import { Dates, Dic, Data, Cache } from '$utils'
// 查询条件的配置
import { SearchFilter } from '../options/searchColumn'
// 表格的配置
import { tableColumn } from '../options/tableColumn'
// 数据映射
import { mapping } from '../options/mapping'
import appCamersGroup from '@components/app-camera-group'
import appPersonGroupList from '@src/components/business/app-person-group-list'
import blackList from './Blacklist'
import $ from 'jquery'

export default {
  components: {
    appPersonGroupList,
    appCamersGroup,
    // blackList
  },
  data() {
    return {
      codeList:null,
      bkdxFlg:1,
      updateCode:'',
      faceSetId:'',
      upDateList:{},
      action:'新增',
      faceGroup: [],
      statusList:[
        {
          label:'启用',
          value:1
        },
        {
          label:'禁用',
          value:2
        },
        {
          label:'不限',
          value:3
        }
      ],
      flagObject:false,
      groupList:false,
      groupListCreate:false,
      controlObject:false,
      createControlObject:false,
      confidenceThreshold:0,
      formNew: {
        name:'',
        confidenceThreshold:70,
        hitType: '',
        repositoriesCode :'',
        // groupList:[{
        //   repositoriesCode: ''
        // }],
        bayonetList: [],
        bayonetParams:[],
        description:''
      },
      rules: {
        name: [
          {required: true,message:'请输入布控名称'}
        ],
        threshold: [
          {required: true}
        ],
        hitType: [
          {required: true,message:'请选择布控类型'}
        ],
        faceTime: [
          {required: true}
        ],
        repositoriesCode: [
          {required: true,message:'请选择布控对象'}
        ],
        faceNum: [
          {required: true}
        ],
        bayonetList:[
          {required: true,message:'请选择摄像机组'}
        ],
        pictureQuality:[
          {required: false}
        ]
      },
      tableLoading: false,
      controlWindowShow: false,
      cameraWindowShow: false,
      repositoriesName: '',
      //   搜索表单的数据
      formData: {
        // 布控名称
        name: '',
        // 默认状态是不限 1：启用，2：不启用，3：不限
        status: 3,
        repositoriesCode: [],
        // 时间段
        daterange: [],
        bayonetList: [],
        type:''
      },
      searchData: {
        // 布控名称
        name: '',
        // 默认状态是不限 1：启用，2：不启用，3：不限
        status: 3,
        repositoriesCode: [],
        // 时间段
        daterange: [],
        bayonetList: [],
        type:''
      },
      groupSelect: null,
      checkedData: [], // 选中的数据
      //  搜索表单的配置
      optionForm: {
        //让自带的提交和清空按钮隐藏
        submitBtn: false,
        emptyBtn: false,
        submitPosition: 'center',
        submitText: '提交',
        labelPosition: 'left',
        span: 12,
        clearable: true,
        menuBtn: false,
        labelWidth: 100,
        column: SearchFilter()
      },
      centerDialogVisible: false, // 启用布控
      // 存储布控任务的数据
      taskCenterData: [],
      page: {
        // 当前页
        currentPage: 1,
        // 查询记过总计
        total: 0,
        // 每页默认显示条数
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10
      },
      //  表格任务的的配置项
      optionTabTask: {
        addBtn: false,
        refreshBtn: false,
        searchBtn: false,
        stripe: true,
        maxHeight: '100%',
        page: true,
        editBtn: false,
        delBtn: false,
        header: false,
        emptyText: this.$t('personCm.label.nodata'),
        // 行可勾选
        selection: true,
        column: tableColumn()
      },
      hitTypeList: Dic.find('SENU027001')
    }
  },
  computed: {
    showBayonetList() {
      return this.formNew.bayonetList.join(', ')
    }
  },
  watch: {
    checkedData (val) {
      const length = val.length
      if (!length) {
        return false
      }
      if (length === this.taskCenterData.length) {
        setTimeout(() => {
            $('.el-table__fixed-header-wrapper label.el-checkbox>span').attr('class', 'el-checkbox__input is-checked')
        })
      } else {
        setTimeout(() => {
            $('.el-table__fixed-header-wrapper label.el-checkbox>span').attr('class', 'el-checkbox__input is-indeterminate')
        })
      }
    }
  },
  mounted() {
    this.queryFaceGroup()
    document.addEventListener('click',(data)=>{
      console.log('data',data.target.nodeName);
      if (data.target.nodeName!="INPUT"&&data.target.nodeName!="I") {
        this.groupListCreate = false;
        this.createControlObject = false;
        this.flagObject = false;
        this.groupList = false;
      }
      // this.groupListCreate = false;
      // this.createControlObject = false;
      // this.flagObject = false;
      // this.groupList = false;
    })
    this.tableLoading = true
    this.queryControlTask()
    this.tableLoading = false
  },
  methods: {
    /*
     *@name: 清除选中名单组
     *@param:{type} 
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-07-12 16:37:25
    */
    clearGroup () {
      this.formData.repositoriesCode = ''
      this.repositoriesName = ''
      this.groupSelect = null
    },
    toggleCameraShow() {
      this.cameraWindowShow = true
    },
    /*
     *@name: 名单组选中回填
     *@param:{type} 
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-07-12 16:17:58
    */
    groupChange (data) {
      this.repositoriesName = `${data.type.label}：${data.group.name}`
      this.formData.repositoriesCode = data.group.code
      this.groupSelect = data.type
    },
    /*
     *@name: 打开名单组选取控件
     *@param:{type} 
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-07-12 14:51:33
    */
    openPersonGroup () {
      if (this.groupSelect) {
        this.$refs['appPersonGroupList'].open(1, [{label: this.$t('personCm.label.blackList'), value: 2}, {label: this.$t('personCm.label.whiteList'), value: 3}], this.groupSelect.value, this.formData.repositoriesCode)
      } else {
        this.$refs['appPersonGroupList'].open(1, [{label: this.$t('personCm.label.blackList'), value: 2}, {label: this.$t('personCm.label.whiteList'), value: 3}], 2)
      }
    },
    searchTask(searchData) {
        this.page.currentPage = 1
        this.searchData = searchData
        this.queryControlTask()
    },
    // 查询布控任务接口
    queryControlTask() {
      this.tableLoading = true
      let baseParams = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }
      // 布控查询相关参数
      let queryPersonnelControlVo = {}
      // 布控名称
      queryPersonnelControlVo.name = this.searchData.name
      // 布控状态
      queryPersonnelControlVo.status = this.searchData.status
      // 布控名单组
      queryPersonnelControlVo.repositoriesCode = this.repositoriesCode
      // 摄像机组
      queryPersonnelControlVo.bayonetList = this.searchData.bayonetParams
      // 类型
      queryPersonnelControlVo.type = this.searchData.type
      // 布控时间段
      let daterange = this.searchData.daterange
      if (daterange && daterange.length) {
        queryPersonnelControlVo.startTime = Dates.dayjs(daterange[0]).format("YYYY-MM-DD")
        queryPersonnelControlVo.endTime = Dates.dayjs(daterange[1]).format("YYYY-MM-DD")
      }
      console.log('params',queryPersonnelControlVo)
      this.$fetch(api.queryPersonnelTask,
        _.merge(baseParams, queryPersonnelControlVo)
      ).then(response => {
        this.tableLoading = false
        console.log('this.tableLoading', this.tableLoading)
        if (response.success) {
          this.taskCenterData = response.returnObj || []
          this.page.total = Number(response.prompt)
          this.$refs['iocCrud'].selectClear()
        } else {
          this.$message({
            message: response.msgContent,
            type: 'error'
          })
        }
      })
    },
    // 重置表单并查询任务
    resetform() {
      // this.$refs.form.resetForm()
      // this.clearGroup()
      this.searchData = {
        // 布控名称
        name: '',
        // 默认状态是不限 1：启用，2：不启用，3：不限
        status: '',
        repositoriesCode: [],
        // 时间段
        daterange: [],
        bayonetList: [],
        type: ''
      },
      this.faceSetId = "";
      //   刷新列表
      this.page.currentPage = 1;
      this.queryControlTask()
    },
    // 创建布控任务
    createControl() {
      this.action = '新增'
      this.formNew = {
        name:'',
        confidenceThreshold:Number(Cache.get('SYS_YUZHI')),
        hitType:'',
        repositoriesCode :'',
        bayonetList: [],
        description:'',
        bayonetParams:[]
      }
      this.flagObject = false;
      this.groupList = false;
      this.createControlObject = false;
      // this.groupListCreate = false;
      this.controlWindowShow = true;
      // this.$router.push({
      //   path: '/personControl/create',
      //   name: 'controlCreate'
      // })
    },
        // 取消新增修改名单
    cancelListForm () {
      console.log('执行', this.formNew)
      // this.formNew.name = ''
      // this.formNew.confidenceThreshold = 50
      // this.formNew.type = ''
      // this.formNew.repositoriesCode = ''
      // this.formNew.bayonetList = ''
      // this.$set(this.formNew, bayonetList, [])
      // this.formNew.bayonetParams = []
      // this.formNew.occupation = ''
      // this.formNew.description = ''
      this.$refs['ruleForm'].clearValidate()
      this.$refs['ruleForm'].resetFields()
      // this.controlWindowShow = false
    },
    // 编辑布控
    editControl(row) {
      this.upDateList = row;
      let params = {
        code: row.code?row.code : ''
      }
      this.$fetch(api.queryPersonnelTaskDetails, params).then( res => {
        if(res.success) {
          this.formNew.repositoriesCode = [];
          res.returnObj[0].groupList.map( item => {
            this.formNew.repositoriesCode.push(item.repositoriesCode)
          })
          // this.formNew.repositoriesCode = 
          // res.returnObj[0].groupList.length?res.returnObj[0].groupList[0].repositoriesCode: ''
        }
      })
      this.action = '修改';
      this.formNew.name = row.name;
      this.formNew.confidenceThreshold = row.confidenceThreshold;
      this.formNew.hitType = row.hitType;
      // this.formNew.repositoriesCode = row.cameraGoupList[0].bayonetName;
      this.formNew.bayonetList = []
      row.cameraGoupList.map((val)=>{
        this.formNew.bayonetParams.push(val.code);
        this.formNew.bayonetList.push(val.bayonetName);
      });
      this.formNew.description = row.description;
      this.updateCode = row.code;
      console.log('row',row)
      this.flagObject = false;
      this.createControlObject = false;
      this.controlWindowShow = true;
    },
    // 删除布控
    deleteControl(row, index) {
      // 启用状态无法删除
      if (row.status === 1) {
        return this.$message({
          message: this.$t('personCm.message.unableDelete'),
          type: 'warning',
          showClose: true,
        })
      }
      let controlTaskList = []
      controlTaskList.push(row.code)
      this.$confirm(this.$t('personCm.message.deleteWarn'),this.$t('personCm.title.remind') , {
        confirmButtonText: this.$t('personCm.button.confirm'),
        cancelButtonText: this.$t('personCm.button.cancel'),
        type: 'warning'
      })
        .then(() => {
          this.$fetch(api.deletePersonnelTask, {
            controlTaskList: controlTaskList
          }).then(response => {
            if (!response.success) {
              this.$message.error(response.msgContent)
              return
            }
            this.$message({
                message: this.$t('personCm.message.deleteOk'),
                type: 'success',
                showClose: true,
            })
            this.queryControlTask() // 刷新列表
          })
        })
    },
    // 启用 禁用 status id
    openControl(row, status) {
      let stateLable = ''
      if (status === 1) {
        stateLable = this.$t('personCm.message.startWarn')
      }
      if (status === 2) {
        stateLable = this.$t('personCm.message.disableWarn')
      }
      let controlTaskList = []
      controlTaskList.push(row.code)
      let param = {
        controlTaskList,
        status: status
      }
      this.$confirm(stateLable, this.$t('personCm.title.remind'), {
        confirmButtonText: this.$t('personCm.button.confirm'),
        cancelButtonText: this.$t('personCm.button.cancel'),
        type: 'warning'
      })
        .then(() => {
          this.$fetch(
            api.startStopPersonnelTask,
            param
          ).then(response => {
            if (!response.success) {
              this.$message.error(response.msgContent)
              return
            }
            this.$message.success(status === 1 ? this.$t('personCm.title.successStart') : this.$t('personCm.title.successDisable'))
            this.queryControlTask()
          })
        })
    },
    // 每页显示条数发生变化，页码为1，再次刷新表格
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      this.queryControlTask()
    },
    // 页码发生改变
    currentChange(val) {
      this.page.currentPage = val
      this.queryControlTask()
    },
    // 单选 全选每一项
    handleSelectionChange(items) {
      this.checkedData = items.map(item => {
        return item
      })
    },
    // 批量启用布控
    startControlNums(status) {
      if (!this.checkedData.length && status === 1) {
        // 是否选中
        this.$message.warning(this.$t('personCm.message.batchStart'))
        return
      }
      let or = true
      this.checkedData.map(item => {
        // 启用停止
        if (item.status === 1) {
          or = false
        }
      })
      if (!or) {
        this.$message.warning(this.$t('personCm.message.starting'))
        return false
      }
      let controlTaskList = []
      this.checkedData.map(item => {
        controlTaskList.push(item.code)
      })
      let param = {
        controlTaskList,
        status: status
      }
      this.$confirm(this.$t('personCm.message.someStart'),this.$t('personCm.title.remind'), {
        confirmButtonText: this.$t('personCm.button.confirm'),
        cancelButtonText: this.$t('personCm.button.cancel'),
        type: 'warning'
      })
        .then(() => {
          this.$fetch(
            api.startStopPersonnelTask,
            param
          ).then(response => {
            if (!response.success) {
              this.$message.error(response.msgContent)
              return
            }
            this.$message.success(this.$t('personCm.title.successStart'))
            this.$refs.iocCrud.selectClear()
            this.queryControlTask()
          })
        })
    },
    // 批量禁用布控
    prohibitControlNums(status) {
      if (!this.checkedData.length && status === 2) {
        // 是否选中
         this.$message({
          message: this.$t('personCm.message.batchDisable'),
          type: 'warning',
          showClose: true,
          })
        return
      }
      let or = true
      this.checkedData.map(item => {
        // 启用停止
        if (item.status === 2) {
          or = false
        }
      })
      if (!or) {
        this.$message.warning(this.$t('personCm.message.disableing'))
        return false
      }
      let controlTaskList = []
      this.checkedData.map(item => {
        controlTaskList.push(item.code)
      })
      let param = {
        controlTaskList,
        status: status
      }
      this.$confirm(this.$t('personCm.message.someDisable'), this.$t('personCm.title.remind'), {
        confirmButtonText: this.$t('personCm.button.confirm'),
        cancelButtonText: this.$t('personCm.button.cancel'),
        type: 'warning'
      })
        .then(() => {
          this.$fetch(
            api.startStopPersonnelTask,
            param
          ).then(response => {
            if (!response.success) {
              this.$message.error(response.msgContent)
              return
            }
            this.$message.success(this.$t('personCm.title.successDisable'))
            this.$refs.iocCrud.selectClear()
            this.queryControlTask()
          })
        })
    },
    // 批量删除布控
    batchDelete() {
      if (!this.checkedData.length) {
        // 是否选中
        this.$message.warning(this.$t('personCm.message.batchDelete'))
        return
      }
      let or = true
      this.checkedData.map(item => {
        // 启用停止
        if (item.status === 1) {
          or = false
        }
      })
      if (!or) {
        this.$message.warning(this.$t('personCm.message.deleteStarting'))
        return false
      }
      let controlTaskList = []
      this.checkedData.map(item => {
        controlTaskList.push(item.code)
      })
      this.$confirm(this.$t('personCm.message.someDelete'), this.$t('personCm.title.remind'), {
        confirmButtonText: this.$t('personCm.button.confirm'),
        cancelButtonText: this.$t('personCm.button.cancel'),
        type: 'warning'
      }).then(() => {
        this.$fetch(api.deletePersonnelTask, {
          controlTaskList: controlTaskList
        }).then(response => {
            if (response.success) {
              this.$message.success(this.$t('personCm.message.deleteOk'))
              this.queryControlTask()
            } else {
              this.$message.error(response.msgContent)
            }
          }).catch(() => {
            this.$message.error(this.$t('personCm.message.deleteNo'))
          })
        })
    },
    showControlObject(){
      // this.controlObject = true;
    },
    hideControlObject(){
      // this.controlObject = false;
    },
    bkdx(){
      this.flagObject = !this.flagObject;
      this.bkdxFlg = 1;
      // this.controlObject = !this.controlObject
    },
    showGroupList(){
      // this.groupList = true;
    },
    hideGroupList(){

    },
    sxjz(){
      this.groupList = !this.groupList
    },
    sxjzList(){
      this.groupListCreate = !this.groupListCreate
    },
    createBkdx(){
      this.flagObject = false;
      this.createControlObject = !this.createControlObject;
      this.bkdxFlg = 2;
    },
    changeObject(data){
      console.log('data',data);
      this.codeList = data;
      if(this.bkdxFlg==1){
        this.faceSetId = data.code;
      }else if(this.bkdxFlg==2){
        this.faceSetId = data.faceSetId;
      }
      if (this.flagObject) {
        this.searchData.repositoriesCode = data.name;
        this.bkdx()
      }else{
        this.formNew.repositoriesCode = data.name;
        this.createControlObject = !this.createControlObject;
      }
    },
    changeCamersGroup(data,type){
      console.log('set',data);
      console.log('type',type);
      if (type===2) {
        this.searchData.bayonetList = [];
        this.searchData.bayonetParams = [];
        data.map((val)=>{
          this.searchData.bayonetList.push(val.bayonetName)
          this.searchData.bayonetParams.push(val.code)
        });
      }else if (type===1) {
        this.formNew.bayonetList = [];
        this.formNew.bayonetParams = [];
        data.map((val)=>{
          this.formNew.bayonetList.push(val.bayonetName)
          this.formNew.bayonetParams.push(val.code)
        });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        console.log('valid',valid)
        if (this.action=='新增') {
          if (valid) {
            console.log(this.formNew);
            let params = {}
            params.groupList = []
            params.bayonetList = []
            params.name = this.formNew.name;
            params.confidenceThreshold = this.formNew.confidenceThreshold;
            // params.type = this.formNew.type;
            params.hitType = this.formNew.hitType;
            params.description = this.formNew.description;
            this.formNew.repositoriesCode.forEach( item => {
              params.groupList.push({
                repositoriesCode:item
              });
            })
            this.formNew.bayonetParams.map((val)=>{
              params.bayonetList.push({
                bayonetCode:val
              })
            });
            console.log('params', params)
            this.$fetch(api.addPersonnelTask,params).then(res=>{
              console.log('res',res);
              this.controlWindowShow = false;
              if(res.success){
                this.formData.repositoriesCode = ''
                this.queryControlTask()
                this.$message.success(res.msgContent);
              }else{
                this.$message.error(res.msgContent);
              }
            })
          } else {
            return false;
          }
        }else{
          if (this.action=='修改'){
               if (valid) {
                console.log(this.formNew);
                let params = {}
                params.groupList = []
                params.bayonetList = []
                params.name = this.formNew.name;
                params.confidenceThreshold = this.formNew.confidenceThreshold;
                // params.type = this.formNew.type;
                params.hitType = this.formNew.hitType;
                params.description = this.formNew.description;
                params.code = this.updateCode;
                this.formNew.repositoriesCode.forEach( item => {
                  params.groupList.push({
                    repositoriesCode:item
                  });
                })
                this.formNew.bayonetParams.map((val)=>{
                  params.bayonetList.push({
                    bayonetCode:val
                  })
                });
                this.$fetch(api.updatePersonnelTask,params).then(res=>{
                  if(res.success) {
                    this.controlWindowShow = false;
                    this.queryControlTask()
                  }else{
                    this.$message.error(res.msgContent)
                  }
                })
              } else {
                return false;
              }
          }
        }
      });
    },
    closeDia(done){
      this.groupListCreate = false;
      done()
    },
    queryFaceGroup() {
      let params = {}
      this.$fetch(api.queryGroup, params).then(res => {
        if(res.success){
          this.faceGroup = res.returnObj;
        }
      })
    }
  }
}
</script>
<style lang="scss">
@import '../style/Index.scss';
.carPatrolBlack-container.person-mg {
    .list-content {
        .right-name {
            .el-form-item__content {
                overflow: hidden;
                word-break:keep-all;
                white-space:nowrap;
                text-overflow:ellipsis;
            }
        }
    }
}
</style>
<style lang="scss">
.personControl {
  .roster-manage-page {
    flex: 1;
    .el-tooltip {
      cursor: pointer;
    }
    .group-list {
      display: flex;
      flex-direction: row;
      position: relative;
      i {
        position: absolute;
        top: 6px;
        cursor: pointer;
        right: 30px;
      }
      span {
        margin-left: 10px;
        cursor: pointer;
      }
    }
    .table-tool {
      line-height: 52px;
      margin-right: 5px;
      padding-left: 10px;
      border-bottom: 1px solid rgba(151, 150, 150, 0.4);
      margin-bottom: 15px;
    }
    .cut-line {
      margin-bottom: 20px;
      height: 1px;
      border-bottom: 1px solid rgba(151, 150, 150, 0.4);
    }
    .control-content {
      margin: 30px;
      .petrol-task-search {
        height: 80px;
        margin-top: 30px;
        .demo-form-item {
          margin-right: 60px;
        }
      }
      .control-list .control-list-content {
        .icon {
          margin-right: 4px;
        }
      }
    }
    .ioc-form__item--left .el-form-item__label {
      text-align: right !important;
    }
  }
  .search-form__button {
    .el-button {
      margin-left: 20px;
    }
  }
  .open-cameta-button {
    color: #0086ff;
    font-weight: bolder;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 80%;
  }
  .camera-list {
    width: 200px;
    position: relative;
    // top: -28px;
    border: 1px solid #596f94;
    height: 100px;
    padding-left: 10px;
  }
  .el-textarea__inner{
    background: #191d31;
  }
  .el-input-number--small{
    width: 200px;
  }
  .el-input-number__decrease, .el-input-number__increase{
    background: transparent;
    border: none;
  }
  .el-input-number.is-controls-right .el-input-number__decrease {
    border: none;
  }
  .el-input-number.is-controls-right .el-input-number__increase{
    border: none;
  }
  .ioc-crud__table{
    padding: 0;
  }
  .el-tree-node{
    background:rgb(35, 54, 93);
  }
  .el-message-box{
    background-color: #20253f;
  }
  .select-repositories{
    flex:1;
    margin-right:8px;
    position:relative;
    .el-select__tags-text{
      overflow: hidden;
      width:100px;
      // display: inline-block;
      white-space:nowrap;
      text-overflow:ellipsis;
      // line-height: 19px;
    }
  }
}
</style>